import React from "react";
import { Modal, Button, Typography, Space, Flex } from "antd";
import { RobotFilled, CheckCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const { Title, Text, Paragraph } = Typography;

interface UpgradePackageModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  featureName?: string;
}

const UpgradePackageModal: React.FC<UpgradePackageModalProps> = ({
  open,
  onClose,
  title = "Upgrade Service Plan",
  featureName = "Bot Integrations (Automation Reports)",
}) => {
  const navigate = useNavigate();

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={480}
      destroyOnClose
      styles={{
        content: {
          borderRadius: 16,
          padding: 24,
          overflow: "hidden",
        },
      }}
    >
      <div style={{ textAlign: "center" }}>
        {/* Animated Icon Badge */}
        <div
          style={{
            width: 72,
            height: 72,
            borderRadius: "50%",
            background: "linear-gradient(145deg, #fbe18d 0%, #f4c93b 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 16px",
            boxShadow: "0 8px 24px rgba(244, 201, 59, 0.35)",
            color: "#111",
            fontSize: 36,
          }}
        >
          <RobotFilled />
        </div>

        {/* Title & Subtitle */}
        <Title level={4} style={{ marginBottom: 4, fontWeight: 700 }}>
          {title}
        </Title>
        <Text
          type="secondary"
          style={{ fontSize: 14, display: "block", marginBottom: 20 }}
        >
          The{" "}
          <Text strong style={{ color: "#d97706" }}>
            {featureName}
          </Text>{" "}
          feature requires a plan upgrade.
        </Text>

        {/* Info Card */}
        <div
          style={{
            background:
              "linear-gradient(180deg, rgba(244, 201, 59, 0.08) 0%, rgba(243, 244, 246, 0.6) 100%)",
            border: "1px solid rgba(244, 201, 59, 0.3)",
            borderRadius: 12,
            padding: "16px 20px",
            textAlign: "left",
            marginBottom: 20,
          }}
        >
          <Text
            strong
            style={{
              fontSize: 14,
              display: "block",
              marginBottom: 12,
              color: "#1f2937",
            }}
          >
            Upgrade Benefits:
          </Text>

          <Space direction="vertical" size={10} style={{ width: "100%" }}>
            <Flex align="flex-start" gap={10}>
              <CheckCircleOutlined
                style={{ color: "#10b981", fontSize: 16, marginTop: 3 }}
              />
              <Text style={{ fontSize: 13, color: "#4b5563" }}>
                Automated revenue & shift report notifications sent via{" "}
                <b>Telegram </b>.
              </Text>
            </Flex>
            <Flex align="flex-start" gap={10}>
              <CheckCircleOutlined
                style={{ color: "#10b981", fontSize: 16, marginTop: 3 }}
              />
              <Text style={{ fontSize: 13, color: "#4b5563" }}>
                Real-time instant status updates for Store Owners & Managers
                anytime.
              </Text>
            </Flex>
            <Flex align="flex-start" gap={10}>
              <CheckCircleOutlined
                style={{ color: "#10b981", fontSize: 16, marginTop: 3 }}
              />
              <Text style={{ fontSize: 13, color: "#4b5563" }}>
                Configure Bots & Chat IDs for automated reporting.
              </Text>
            </Flex>
          </Space>
        </div>

        {/* Notice */}
        <Paragraph style={{ color: "#4b5563", fontSize: 13, marginBottom: 24 }}>
          Upgrade your store service plan directly to unlock all features
          instantly.
        </Paragraph>

        {/* Action Buttons */}
        <Flex gap={12} justify="center">
          <Button
            size="large"
            onClick={onClose}
            style={{
              minWidth: 100,
              borderRadius: 8,
              fontWeight: 500,
            }}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            size="large"
            onClick={() => {
              onClose();
              navigate("/upgrade-package");
            }}
            style={{
              minWidth: 140,
              borderRadius: 8,
              background: "linear-gradient(145deg, #fbe18d, #f4c93b)",
              color: "#111",
              border: "none",
              fontWeight: 700,
              boxShadow: "0 4px 12px rgba(244, 201, 59, 0.4)",
            }}
          >
            Upgrade Now
          </Button>
        </Flex>
      </div>
    </Modal>
  );
};

export default UpgradePackageModal;
